module.exports = __webpack_public_path__ + "img/ubic.fde4dc48.gif";